import { createEventService } from '@radevents/shared';
import api from './api';
import { meineEventsVeraltet } from '../hooks/useKopfHinweise';

const basis = createEventService(api);

// Merken und Entfernen ändern die Zahl an „Meine Events“ im Kopf.
export const eventService = {
  ...basis,
  addFavorite: async (eventId: number) => { await basis.addFavorite(eventId); meineEventsVeraltet(); },
  removeFavorite: async (eventId: number) => { await basis.removeFavorite(eventId); meineEventsVeraltet(); },
};
export default eventService;
